<template>
  <Header_m/>
  <Enterprise_index_m></Enterprise_index_m>
  <Enterprise_page_m></Enterprise_page_m>
  <Footer_m></Footer_m>
</template>

<script>
import Enterprise_index_m from "@/components/CN_mobile/enterprise/Enterprise_index_m";
import Enterprise_page_m from "@/components/CN_mobile/enterprise/Enterprise_page_m";
import Footer_m from "@/components/CN_mobile/Footer_m";
import Header_m from "@/components/CN_mobile/Header_m";
export default {
  name: 'Enterprise_m',
  components: {Header_m, Enterprise_page_m, Enterprise_index_m,Footer_m},
}

</script>